import { Membership } from '@citruscamps/citrus-client'
import { faClock, faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { DateTime } from 'luxon'
import React from 'react'

interface IProps extends React.HTMLAttributes<HTMLSpanElement> {
  membership: Membership
}

export const MembershipStatusBadge = ({ membership, className, ...props }: IProps) => {
  const cancelAt: DateTime | undefined =
    (membership.cancel_at && DateTime.fromISO(membership.cancel_at).plus({ millisecond: 1 })) ||
    undefined
  if (cancelAt && membership.status !== 'canceled' && cancelAt > DateTime.local()) {
    return (
      <span
        className={`badge rounded-pill text-bg-light text-capitalize ms-2 ${
          className || ''
        }`.trim()}
        {...props}
      >
        <FontAwesomeIcon icon={faClock} style={{ height: 13.5 }} /> Cancels{' '}
        {cancelAt.toLocaleString(DateTime.DATE_MED)}
      </span>
    )
  }
  if (cancelAt && membership.status !== 'canceled') {
    return (
      <span
        className={`badge rounded-pill text-bg-danger text-capitalize ${className || ''}`.trim()}
        {...props}
      >
        <FontAwesomeIcon icon={faExclamationTriangle} style={{ height: 13.5 }} /> Failed to cancel
      </span>
    )
  }
  switch (membership.status) {
    case 'active':
      return (
        <span
          className={`badge rounded-pill text-bg-success text-capitalize ${className || ''}`.trim()}
          {...props}
        >
          {membership.status.split('_').join(' ')}
        </span>
      )
    case 'past_due':
      return (
        <span
          className={`badge rounded-pill text-bg-danger text-capitalize ${className || ''}`.trim()}
          {...props}
        >
          {membership.status.split('_').join(' ')}
        </span>
      )
    default:
      return (
        <span
          className={`badge rounded-pill text-bg-light text-capitalize ${className || ''}`.trim()}
          {...props}
        >
          {membership.status.split('_').join(' ')}
        </span>
      )
  }
}
